class SEOIframeParser {
  constructor() {}

  setContext(context) {
    this.iFrameContext = context;
  }

  getData() {
    if (!this.iFrameContext) {
      return {};
    }

    return {
      publicUrl: jQuery(this.iFrameContext).find('meta[property="og:url"]').attr("content"),
      google: this.getGoogleMeta(this.iFrameContext),
      facebook: this.getFacebookMeta(this.iFrameContext),
    };
  }

  getFacebookMeta(iframeDocument) {
    iframeDocument = jQuery(iframeDocument);
    return {
      platform: "facebook",
      title: iframeDocument.find('meta[property="og:title"]').attr("content"),
      description: iframeDocument.find('meta[property="og:description"]').attr("content"),
      thumbnail: iframeDocument.find('meta[property="og:image"]').attr("content"),
    };
  }

  getGoogleMeta(iframeDocument) {
    iframeDocument = jQuery(iframeDocument);
    return {
      platform: "google",
      title: iframeDocument.find("title").html(),
      description: iframeDocument.find('meta[name="description"]').attr("content"),
    };
  }
}

window.SEOIframeParser = SEOIframeParser;
